export const CONTACT_EMAIL = 'hello@retailx.dev';

export const sendEmail = () => {
  window.location.href = `mailto:${CONTACT_EMAIL}`;
};
